/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_History_CancelledInputs */

const en_settings_history_cancelled = /** @type {(inputs: Settings_History_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelled`)
};

const id_settings_history_cancelled = /** @type {(inputs: Settings_History_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibatalkan`)
};

/**
* | output |
* | --- |
* | "Cancelled" |
*
* @param {Settings_History_CancelledInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_history_cancelled = /** @type {((inputs?: Settings_History_CancelledInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_History_CancelledInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_history_cancelled(inputs)
	return en_settings_history_cancelled(inputs)
});